import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initLenis, scrollTop, scrollToHash } from "@/lib/lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Markets from "@/pages/Markets";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => scrollToHash(hash), 120);
            return () => clearTimeout(t);
        }
        scrollTop();
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => initLenis(), []);

    return (
        <div className="App grain">
            <BrowserRouter>
                <ScrollToTop />
                <Nav />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/markets" element={<Markets />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/legal/:slug" element={<Legal />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <CookieConsent />
            </BrowserRouter>
        </div>
    );
}

export default App;
